module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainDiv"
  }, [_c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")]), _vm._v(" "), _c('p', {
    staticClass: "page-container"
  }, [_vm._v("网页未找到")]), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("返回首页")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-552f9c87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 1169
// module chunks = 1